import { render, staticRenderFns } from "./EncryptionSettings.vue?vue&type=template&id=1608e64f&scoped=true"
import script from "./EncryptionSettings.vue?vue&type=script&setup=true&lang=ts"
export * from "./EncryptionSettings.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./EncryptionSettings.vue?vue&type=style&index=0&id=1608e64f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1608e64f",
  null
  
)

export default component.exports